import { memo } from 'react';
import GeneralTooltip, { VerticalContentsWrapper, GeneralTooltipProps } from './tooltip';

const DiagramTooltip = ({ children, content, contentProps, ...props }: GeneralTooltipProps) => {
   const toolTipContent = <VerticalContentsWrapper>{content}</VerticalContentsWrapper>;

   return (
      <GeneralTooltip
         {...props}
         content={toolTipContent}
         contentProps={{ zIndex: 9999, ...contentProps }}
      >
         {children}
      </GeneralTooltip>
   );
};

export default memo(DiagramTooltip);
